/**
 * Canonical route metadata for the content block editor used by app hover-help
 * and "Tell me what this means" content.
 *
 * @see docs/guides/HOVER_HELP.md
 */
export const EDITABLE_CONTENT_BLOCK_ROUTE_TITLE = "Content block editor";

/**
 * The editor remains a hidden detail route under Guides because operators
 * usually arrive here from help-content workflows rather than direct sidebar
 * navigation.
 */
export const EDITABLE_CONTENT_BLOCK_ROUTE_SUBTITLE =
  "Edit help content shown in the customer app, then check the result in the app.";

export const EDITABLE_CONTENT_BLOCK_DEFAULT_EDITOR_HTML =
  "<p>This section does not have any content yet</p><ul>Replace this text with your own content.</ul><ul>Use the menu above to apply formatting and upload images.</ul><ul>Save your changes when you are finished.</ul>";

export const EDITABLE_CONTENT_BLOCK_EDITOR_TIPS = [
  "Use the menu above the editor to apply formatting, insert formulas, and upload images.",
  "If formatting becomes messy, remove it first, split the content into the paragraphs you need, then reapply formatting.",
  "Use the calculator button to insert a formula that renders the customer's live data in the app.",
  "Click an inserted formula chip to edit it.",
  "If you type {{LATEST_MONTH}}, the app will show the reporting month, for example June 2024.",
  "Check spacing around formulas and links so the final sentence reads naturally in the app.",
  "The editor preview is intentionally close to the app, but the final modal may apply slightly different spacing and typography.",
  "Save when you are done, then check the result in the customer app.",
] as const;
